import React from "react";
import EuleriagymMonodimensionalBalanceChart from "./EuleriagymBalanceEvaluationResult/EuleriagymMonodimensionalBalanceChart/EuleriagymMonodimensionalBalanceChart";
import EuleriagymBidimensionalBalanceChart from './EuleriagymBalanceEvaluationResult/EuleriagymBidimensionalBalanceChart/EuleriagymBidimensionalBalanceChart';

import style from "./EuleriagymFunctionalResult.module.sass";
import sitToStandIcon from '../../../../assets/images/sit_to_stand.png';
import standIcon from '../../../../assets/images/stand.png';
import standToSitIcon from '../../../../assets/images/stand_to_sit.png';
import sitIcon from '../../../../assets/images/sit.png';
import BalanceOccupation from '../../icons/BalanceOccupation';
function EuleriagymFunctionalSitToStandResult({ result, color }) {
    const header = result.header;
    const labels = result.labels;
    const phases = result.phases;
    const percentages = result.percentages;
    console.log("result", result)
    console.log("percentages", percentages)


    const measureUnit = (unit) => {
        switch (unit) {
            case "%":
                return (
                    <span className={style.measureUnit}>%</span>
                )
            case "cm2":
                return (
                    <span className={style.measureUnit}>cm<sup>2</sup></span>
                )
            default:
                return (
                    <span className={style.measureUnit}>cm</span>
                )
        }
    }
    const percentagesRows = () => {
        return percentages.values.map((percentage, index) => {
            return (
                <div className={style.resultPercentageRow} key={index}>
                    <div className={style.icon}>
                        <BalanceOccupation quarter={percentage.quarter} />
                    </div>
                    {tableSidedValues(percentage.values, "%")}
                </div>
            )
        })
    }

    const tableSidedValues = (values, unit = "cm") => {
        if (values.length == 2) {
            return values.map((value, index) => {
                return (
                    <div
                        key={index}
                        className={tableValueClass(index)}
                    >
                        {value}
                        {measureUnit(unit)}
                    </div>
                )
            })
        } else {
            return (
                <div className={style.value}>
                    {values[0]}
                    {measureUnit(unit)}
                </div>
            )
        }
    }

    const tableValueClass = (index) => {
        let valueClass = {};
        if (index == 0) {
            if (enableLeft) {
                valueClass = style.leftValue
            } else {
                valueClass = `${style.leftValue} ${style.disabled}`
            }
        } else {
            if (enableRight) {
                valueClass = style.rightValue
            } else {
                valueClass = `${style.rightValue} ${style.disabled}`
            }
        }
        return valueClass
    }

    return (
        <div className={style.container}>

            {/* ===== METRICS ===== */}
            <div className={style.metrics}>
                <div className={style.metricsRow}>
                    {(result.modality[0].id == 3 || result.modality[0].id == 4) && (
                        <>
                            <div className={style.metricInline}>
                                <span className={style.label}>{labels.steps}</span>
                                <span className={style.value} style={{ color }}>{header.steps}</span>
                            </div>
                            <div className={style.metricInline}>
                                <span className={style.label}>{labels.cadence}</span>
                                <span className={style.value} style={{ color }}>{header.cadence?.toFixed(0)} {labels.sm}</span>
                            </div>
                        </>
                    )}
                    {result.modality[0].id == 1 && (
                        <div className={style.metricInline}>
                            <span className={style.label}>{labels.repetitions}</span>
                            <span className={style.value} style={{ color }}>{header.repetitions}</span>
                        </div>
                    )}
                    {result.modality[0].id == 2 && (
                        <div className={style.metricInline}>
                            <span className={style.label}>{labels.duration}</span>
                            <span className={style.value} style={{ color }}>{header.duration}</span>
                        </div>
                    )}
                </div>

                <div className={style.metricsRow}>
                    {(result.modality[0].id == 3 || result.modality[0].id == 4) && (
                        <div className={style.metricInline}>
                            <span className={style.label}>{labels.duration}</span>
                            <span className={style.valueSmall}>{header.duration?.toFixed(1)} s</span>
                        </div>
                    )}
                    <div className={style.metricInline}>
                        <span className={style.label}>{labels.workTime}</span>
                        <span className={style.valueSmall}>{header.workTime?.toFixed(1)} s</span>
                    </div>
                    <div className={style.metricInline}>
                        <span className={style.label}>{labels.reactionTime}</span>
                        <span className={style.valueSmall}>{header.reactionTime?.toFixed(1)} s</span>
                    </div>
                </div>
            </div>

            {/* ===== PHASE TITLE ===== */}
            <div className={style.phaseTitle}>
                {labels.durationMovement}
            </div>

            {/* ===== PHASES ===== */}
            <div className={style.phases}>
                {phases.map((phase, index) => (
                    <div key={index} className={style.phase}>
                        <img
                            src={getPhaseIcon(phase.label)}
                            className={style.icon}
                            alt={phase.label}
                        />

                        <div className={style.phaseData}>
                            <div className={style.phaseValue}>
                                {phase.value?.toFixed(1)} s
                            </div>
                            <div className={style.phaseLabel}>
                                {formatPhaseLabel(phase.label)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* ===== ANGLE CHART ===== */}
            <EuleriagymMonodimensionalBalanceChart
                colors={["#FFA411"]}
                clampedData={[result.angleChart.data]}
                data={[result.angleChart.data]}
                labels={result.angleChart.labels}
                directions={["", " "]} // niente sinistra/destra
                title={labels.hipAngle}
                min = {-30}
                max = {105}
                label_unit_y={"°"}
                reverse={true}
            />

            {/* ===== LOWER BLOCK ===== */}
            <div className={style.lowerBlock}>
                <DeviationSummary deviations={result.deviations} labels={labels} />
                <div className='row'>
                    <div className='col-8 d-flex justify-content-end'>
                        <EuleriagymBidimensionalBalanceChart
                            {...result.stability.bidimensional}
                            colors={["#04CBFF"]}
                        />
                    </div>
                    <div className='col-4 d-flex flex-column align-items-end'>
                        <div style={{ width: "90%" }}>
                            <div className={`${style.resultInfoRow} ${style.resultInfoTitle}`}>
                                <div className={style.title}>{percentages.label}</div>
                            </div>
                            {percentagesRows()}
                        </div>
                    </div>
                </div>
                <EuleriagymMonodimensionalBalanceChart {...result.stability.ap} colors={["#04CBFF"]} min={-20} max={20} label_unit_y={"cm"}/>
                <EuleriagymMonodimensionalBalanceChart {...result.stability.ml} colors={["#04CBFF"]} min={-20} max={20} label_unit_y={"cm"}/>
            </div>
        </div>
    );
}

function getPhaseIcon(label) {
    switch (label) {
        case "sit_to_stand":
            return sitToStandIcon;
        case "stand":
            return standIcon;
        case "stand_to_sit":
            return standToSitIcon;
        case "sit":
            return sitIcon;
        default:
            return null;
    }
}

function formatPhaseLabel(label) {
    switch (label) {
        case "sit_to_stand":
            return "SIT TO STAND";
        case "stand":
            return "STAND";
        case "stand_to_sit":
            return "STAND TO SIT";
        case "sit":
            return "SIT";
        default:
            return label;
    }
}

function DeviationSummary({ deviations,labels }) {
    return (
        <div className={style.deviationBox}>
            <div className={style.deviationTitle}>
                {labels.maxDeviation}
            </div>

            <div className={style.deviationGrid}>
                <div className={style.deviationRow}>
                        <div className={style.deviationRowInner}>
                    <span className={style.deviationLabel}>{labels.forward}</span>
                    <span className={style.deviationValue}>{deviations.forward}°</span>
                    </div>
                </div>
                <div className={style.deviationRow}>
                    <div className={style.deviationRowInner}>
                    <span className={style.deviationLabel}>{labels.right}</span>
                    <span className={style.deviationValue}>{deviations.right}°</span>
                    </div>  
                </div>
                <div className={style.deviationRow}>
                        <div className={style.deviationRowInner}>   
                    <span className={style.deviationLabel}>{labels.backward}</span>
                    <span className={style.deviationValue}>{deviations.backward}°</span>
                    </div>
                </div>
                <div className={style.deviationRow}>
                    <div className={style.deviationRowInner}>   
                    <span className={style.deviationLabel}>{labels.left}</span>
                    <span className={style.deviationValue}>{deviations.left}°</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
function ScatterChart({ result }) {
    return (
        <div className={style.scatterWrapper}>
            <EuleriagymBidimensionalBalanceChart

            />
        </div>
    );
}




function Percentages({ percentages }) {
    const items = [
        { label: "Q1", value: percentages.q1 },
        { label: "Q2", value: percentages.q2 },
        { label: "Q3", value: percentages.q3 },
        { label: "Q4", value: percentages.q4 },
        { label: "Q1+Q3", value: percentages.q1 + percentages.q3 },
        { label: "Q2+Q4", value: percentages.q2 + percentages.q4 },
    ];

    return (
        <div className={style.percentages}>
            <div className={style.sectionTitle}>
                {labels.percentages}
            </div>

            {items.map((item, i) => (
                <div key={i} className={style.percentageRow}>
                    <div className={style.bar}>
                        <div
                            className={style.fill}
                            style={{ width: `${item.value}%` }}
                        />
                    </div>
                    <span>{item.value}%</span>
                </div>
            ))}
        </div>
    );
}
export default EuleriagymFunctionalSitToStandResult;